import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Chip } from '@mui/material';

function App() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    // Fetching data from JSON file
    fetch('ap_data.json')
      .then((response) => response.json())
      .then((data) => {
        const processedData = data
          .map((item, index) => ({
            id: index,
            ...item,
          }));
        setData(processedData);
        setFilteredData(processedData);
      
      });

    // Fetching course names from courses.txt
    fetch('courses.txt')
      .then((response) => response.text())
      .then((text) => {
        const courseLines = text.split('\n');
        const courseNames = courseLines.map((line) => {
          const parts = line.split(',');
          return {
            code: parts[1].trim(), // Extracting the code
            displayName: parts[2].trim() // Extracting the display name
          };
        });
        courseNames.sort((a, b) => a.displayName.localeCompare(b.displayName)); // Sorting alphabetically by display name
        setCourses(courseNames);
      
        /*if (courseNames.length > 0) {
          setSelectedCourse(courseNames[0].code); // Set the first course as selected
        }*/
      });
  }, []);

  useEffect(() => {
    // Define an array of field names that are allowed in the search
    const searchableFields = ['question', 'description', 'tags']; // Add other field names as needed
  
    let filtered = data.filter((item) =>
      Object.entries(item).some(([key, value]) =>
        searchableFields.includes(key) && ( // Check if the field is in the whitelist
          (typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (Array.isArray(value) && value.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())))
        )
      )
    );
    if (selectedCourse) {
      filtered = filtered.filter((item) => item.course === selectedCourse);
    }
    setFilteredData(filtered);
  }, [searchTerm, selectedCourse, data]);
  
  const handleCourseClick = (courseCode) => {
    setSelectedCourse(courseCode === selectedCourse ? '' : courseCode);
  };

//  const isMobile = window.innerWidth < 600;

  const chipStyle = {
    margin: '5px',
    '@media (max-width: 600px)': {
      margin: '2px',
      fontSize: '0.8rem',
      padding: '5px',
    },
  };
  const columns = [
    //{ field: 'course', headerName: 'Course', width: 100 },

    { field: 'form', headerName: 'Year', 
    width: 100,
    //flex: isMobile ? 0 : 1
    },

  
    { field: 'question', headerName: 'Question',  width: 100,
    //flex: isMobile ? 0 : 1,
    renderCell: (params) => 
    params.value ? <a href={params.row.link} target="_blank" rel="noreferrer">{params.value}</a> : null},
    { field: 'link_sg', headerName: 'Rubric', width : 100,
    //flex: isMobile ? 0 : 1,
    renderCell: (params) => 
    params.value ? <a href={params.value} target="_blank" rel="noreferrer">Rubric</a> : null},
    { field: 'link_ans', headerName: 'Sample', width : 100,
    //flex: isMobile ? 0 : 1,
    renderCell: (params) => 
    params.value ? <a href={params.value} target="_blank" rel="noreferrer">Sample</a> : null,
  },

  { field: 'description', headerName: 'Description', 
  width: 400
  //width: isMobile ? 300 : 300,
  //flex: isMobile ? 0 : 1
},
  {
    field: 'tags',
    headerName: 'Tags',
    width: 2000,
    //flex: isMobile ? 0 : 1,
    renderCell: (params) => (
      <div> 
        {params.value.join(', ')} 
      </div>
      ),
    },
  ];

  return (
    <div style={{ margin: '0 auto', padding: '20px' }}>
    <h1>Unofficial FRQ List</h1>

      <TextField
  label="Search Questions and Tags"
  variant="outlined"
  fullWidth
  margin="normal"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  style={{ width: '100%', boxSizing: 'border-box' }}
/>

      <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 20 }}>
        {courses.map(({ code, displayName }) => (
          <Chip
            key={code}
            label={displayName}
            onClick={() => handleCourseClick(code)}
            color={selectedCourse === code ? 'primary' : 'default'}
            style={chipStyle}
            />
        ))}
      </div>

      <DataGrid
        rows={filteredData}
        columns={columns}
        pageSize={10}
        autoHeight // Makes the DataGrid adjust its height automatically
        disableColumnMenu // Optional: Hides the column menu on smaller scree
        sortModel={[{ field: 'form', sort: 'desc' }]} // Set default sort model for the DataGrid
        sortingOrder={['desc', 'asc']}
        sortingMode="client"
        style={{height: 'auto', width: '100%', boxSizing: 'border-box' }}
                />
      <div style={{ marginTop: '30px', textAlign: 'center', fontSize: '0.9em' }}>
    AP® and Advanced Placement® are registered trademarks of the College Board, which was not involved in the production of, and does not endorse, this product.</div>

    </div>
  );
}

export default App;
